import { DatePicker, FormField } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';
import { parseApiDate } from '../utils/data';

type ReferenceDateFieldProps = {
  /** Escolha da URL; `null` = o back usa hoje. */
  value: Date | null;
  /** `date` da resposta, exibida enquanto não há escolha. */
  appliedDate: string | undefined;
  onChange: (date: Date | null) => void;
  hint: string;
};

/** "Situação em": a consulta mostra as alocações vigentes nesse dia (hoje por padrão, como no legado). */
export function ReferenceDateField({
  value,
  appliedDate,
  onChange,
  hint,
}: ReferenceDateFieldProps) {
  const { t } = useTranslation('alocacao');
  return (
    <FormField label={t('consultas.dataReferencia')} hint={hint} className="w-48">
      <DatePicker value={value ?? parseApiDate(appliedDate)} onChange={onChange} />
    </FormField>
  );
}
